import { useMemo } from "react";
import useZustandStore from "../zustandStore/useZustandStore";

const EMPTY = [];
const EMPTY_MAP = {};

// Read the global AMS config with safe defaults, so callers never null-check.
export default function useAmsConfig() {
  const config = useZustandStore((s) => s.config);
  return useMemo(() => {
    const c = config || {};
    return {
      config: c,
      hasConfig: Object.keys(c).length > 0,
      appNames: c.app_names ?? EMPTY,
      appLanguages: c.app_languages ?? EMPTY_MAP,
      languageMapping: c.language_mapping ?? EMPTY_MAP,
      creativeFormats: c.creative_format ?? EMPTY,
      creativeVariations: c.creative_variation ?? EMPTY_MAP,
      visualFormats: c.visual_format ?? EMPTY,
      visualVariations: c.visual_variation ?? EMPTY_MAP,
      moduleTypes: c.module_type ?? EMPTY,
      modules: c.module ?? EMPTY_MAP,
      humanAi: c.human_ai ?? EMPTY,
      scriptTypes: c.script_type ?? EMPTY,
      moderationIssues: c.moderation_issues ?? EMPTY,
      languagesFor: (app) => c.app_languages?.[app] ?? EMPTY,
      modulesFor: (moduleType) => c.module?.[moduleType] ?? EMPTY,
      variationsFor: (base) => c.creative_variation?.[base] ?? EMPTY,
      visualVariationsFor: (base) => c.visual_variation?.[base] ?? EMPTY,
    };
  }, [config]);
}
